module.exports = __webpack_public_path__ + "media/images/pc/stores/suns/magazine/main-visual_beach-photo-d192b0f09a58e07c55378c2a230120c5.webp";